"use client";

import { useEffect, useState } from "react";
import { subscribeToAppEvents } from "../../events";
import { ConsentAcceptedEvent } from "../../events/consent-accepted.event";
import { ConsentNotShowedEvent } from "../../events/consent-not-showed.event";
import { ConsentRejectedEvent } from "../../events/consent-rejected.event";
import { analyticsPurposeId } from "./constants";
import type { PurposeConsents } from "./types";

export function getAnalyticsConsent({ purposeConsents }: { purposeConsents: PurposeConsents }): boolean {
  return purposeConsents?.[analyticsPurposeId] === true;
}

export function useAnalyticsConsent() {
  const [analyticsConsent, setAnalyticsConsent] = useState<boolean | null>(null);

  useEffect(() => {
    const unsubscribe = subscribeToAppEvents((event) => {
      if (
        event instanceof ConsentAcceptedEvent ||
        event instanceof ConsentRejectedEvent ||
        event instanceof ConsentNotShowedEvent
      ) {
        setAnalyticsConsent(getAnalyticsConsent(event.detail));
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return analyticsConsent;
}
